import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

import logo from "../../assets/images/logo.svg";
import logoLightPng from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-dark.png";

import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import SidebarContentTeacher from "pages/TeacherPages/SidebarContentTeacher";
import SidebarContentAdmin from "pages/AdminPages/SidebarContentAdmin";
import SidebarContentCoordinator from "pages/CoordinatorPages/SidebarContentCoordinator";

const Sidebar = props => {
const selectLoginState = state => state.login
const LoginProperties = createSelector(selectLoginState, login => ({
  user: login.user,
}))
const { user } = useSelector(LoginProperties)

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/dashboard" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="17" />
            </span>
          </Link>

          <Link to="/dashboard" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoLightSvg} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoLightPng} alt="" height="38" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {user?.role_id === "1" && <SidebarContentAdmin/>}
          {user?.role_id === "2" && <SidebarContentCoordinator/>}
          {user?.role_id === "3" && <SidebarContentTeacher />}

          {/* {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />} */}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
